__turbopack_context__.v({
  "Cont": "ServicesHero-module-sass-module__fHWG2a__Cont",
  "Content": "ServicesHero-module-sass-module__fHWG2a__Content",
  "Copy": "ServicesHero-module-sass-module__fHWG2a__Copy",
  "ServicesHero": "ServicesHero-module-sass-module__fHWG2a__ServicesHero",
  "Title": "ServicesHero-module-sass-module__fHWG2a__Title",
});
